import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import process from 'process';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: 'login',
  },
  // 首页
  {
    path: '/index',
    name: '使用说明',
    component: () => import('@/views/index/app.vue'),
  },

  // 更新日志
  {
    path: '/updateLog',
    name: '更新日志',
    component: () => import('@/views/updateLog/app.vue'),
  },
  
  // 新建功能管理
  {
    path: '/fun',
    name: '新建功能管理',
    meta: { title: '新建功能管理' , requiresAuth: true},
    component: () => import('@/views/fun/app.vue'),
  },

  // 功能属性管理
  {
    path: '/funDetail',
    name: '功能列管理',
    meta: { title: '功能列管理' , requiresAuth: true},
    component: () => import('@/views/funDetail/app.vue'),
  },

  // 属性值管理
  {
    path: '/funDetailData',
    name: '功能数据管理',
    meta: { title: '功能数据管理' , requiresAuth: true},
    component: () => import('@/views/funDetailData/app.vue'),
  },
// 用户管理
{
  path: '/tbUserList',
  name: '用户管理',
  meta: { title: '用户管理' , requiresAuth: true},
  component: () => import('@/views/tbUser/list.vue'),
},


  // 猜人物页面
  {
    path: '/personAttr',
    name: 'personAttr',
    component: () => import('@/views/personAttr/app.vue'),
  },
 
  
  {
    path: '/tbInviteCode',
    name: 'tbInviteCode',
    component: () => import('@/views/tbInviteCode/app.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  },


  // -------------------------不需要权限的页面---------------------------------------------------
  
  {
    path: '/login',
    name: '409高明',
    component: () => import('@/views/login/login.vue'),
  },
  // 注册
  {
    path: '/tbUser',
    name: 'tbUser',
    component: () => import('@/views/tbUser/app.vue'),
  },
  //该密码
  {
    path: '/tbUserEdit',
    name: '修改密码',
    component: () => import('@/views/tbUserEdit/app.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
